import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "image", "label", "pair", "beforeImage", "afterImage"]

  open(event) {
    const el = event.currentTarget
    const beforeSrc = el.dataset.beforeSrc
    const afterSrc = el.dataset.afterSrc

    if (beforeSrc && afterSrc) {
      this.beforeImageTarget.src = beforeSrc
      this.afterImageTarget.src = afterSrc
      this.pairTarget.classList.remove("hidden")
      this.imageTarget.classList.add("hidden")
      this.labelTarget.classList.add("hidden")
    } else {
      this.imageTarget.src = el.dataset.src
      this.labelTarget.textContent = el.dataset.label || ""
      this.imageTarget.classList.remove("hidden")
      this.labelTarget.classList.remove("hidden")
      this.pairTarget.classList.add("hidden")
    }

    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }
}
